import { useEffect, useState } from 'react';
import './App.css';

function App() {
  const [username, setUsername] = useState('');

  useEffect(() => {
    // Access Telegram Web App SDK through window object
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.ready();
      
      // Get user data from Telegram
      const initData = window.Telegram.WebApp.initData;
      const params = new URLSearchParams(initData);
      const user = params.get('user');
      
      if (user) {
        try {
          const userData = JSON.parse(user);
          setUsername(userData.username || 'No username');
        } catch (e) {
          console.error('Error parsing user data:', e);
        }
      }
    }
  }, []);

  return (
    <div className="container">
      <h1>Telegram Mini App</h1>
      <div className="user-info">
        <p>Your Telegram username:</p>
        <h2>@{username}</h2>
      </div>
    </div>
  );
}

export default App;